
import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("rdf_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/admin/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("rdf_admin_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/admin/login", { email, password });
    localStorage.setItem("rdf_admin_token", res.data.access_token);
    setAdmin(res.data.admin);
    setMustChangePassword(!!res.data.must_change_password);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("rdf_admin_token");
    setAdmin(null);
    setMustChangePassword(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout, mustChangePassword, setMustChangePassword }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
